"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Table = Table;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function Table(props) {
  var caption = props.caption,
      captionClassName = props.captionClassName,
      className = props.className,
      firstCellIsHeader = props.firstCellIsHeader,
      head = props.head,
      rows = props.rows,
      attributes = _objectWithoutProperties(props, ["caption", "captionClassName", "className", "firstCellIsHeader", "head", "rows"]);

  var captionComponent;
  var headComponent;

  if (caption) {
    captionComponent = /*#__PURE__*/_react["default"].createElement("caption", {
      className: "govuk-table__caption ".concat(captionClassName || '')
    }, caption);
  }

  if (head) {
    headComponent = /*#__PURE__*/_react["default"].createElement("thead", {
      className: "govuk-table__head"
    }, /*#__PURE__*/_react["default"].createElement("tr", {
      className: "govuk-table__row"
    }, head.map(function (item, index) {
      var itemClassName = item.className,
          itemFormat = item.format,
          itemChildren = item.children,
          reactListKey = item.reactListKey,
          itemAttributes = _objectWithoutProperties(item, ["className", "format", "children", "reactListKey"]);

      return /*#__PURE__*/_react["default"].createElement("th", _extends({
        key: reactListKey || index,
        scope: "col",
        className: "govuk-table__header ".concat(itemFormat ? "govuk-table__header--".concat(itemFormat) : '', " ").concat(itemClassName || '')
      }, itemAttributes), itemChildren);
    })));
  }

  return /*#__PURE__*/_react["default"].createElement("table", _extends({
    className: "govuk-table ".concat(className || '')
  }, attributes), captionComponent, headComponent, /*#__PURE__*/_react["default"].createElement("tbody", {
    className: "govuk-table__body"
  }, rows.map(function (row, rowIndex) {
    return /*#__PURE__*/_react["default"].createElement("tr", {
      key: row.reactListKey || rowIndex,
      className: "govuk-table__row"
    }, row.map(function (cell, cellIndex) {
      var cellClassName = cell.className,
          cellChildren = cell.children,
          cellFormat = cell.format,
          cellAttributes = _objectWithoutProperties(cell, ["className", "children", "format"]);

      if (cellIndex === 0 && firstCellIsHeader) {
        return /*#__PURE__*/_react["default"].createElement("th", _extends({
          key: cell.reactListKey || cellIndex,
          scope: "row",
          className: "govuk-table__header ".concat(cellClassName || '')
        }, cellAttributes), cellChildren);
      }

      return /*#__PURE__*/_react["default"].createElement("td", _extends({
        key: cell.reactListKey || cellIndex,
        className: "govuk-table__cell ".concat(cellClassName || '', " ").concat(cellFormat ? "govuk-table__cell--".concat(cellFormat) : '')
      }, cellAttributes), cellChildren);
    }));
  })));
}